import { callApi } from './api'

export const getById = async (sitekey, id) => {
  const data = await callApi('GET', `/wheel/${id}/`, sitekey)
  return data
}

export const getByUrl = async (sitekey, url) => {
  const data = await callApi('GET', `/wheel/me/${url}/`, sitekey)
  return data
}

export const create = async (sitekey, wheel) => {
  const data = await callApi('POST', `/wheel/`, sitekey, wheel)
  return data
}

export const update = async (sitekey, wheel) => {
  const data = await callApi('PUT', `/wheel/${wheel.id}/`, sitekey, wheel)
  return data
}

export const deleteWheel = async (sitekey, wheel) => {
  const data = await callApi('DELETE', `/wheel/${wheel.id}/`, sitekey)
  return data
}

export const getAll = async sitekey => {
  const items = []
  const _load = async page => {
    const wheels = await callApi('GET', `/wheel/browse/0/10/`, sitekey)
    items.push(...wheels)
  }
  await _load(0)
  return items
}

export const getGiftById = async (sitekey, wheel_id, id) => {
  const data = await callApi('GET', `/wheel/${wheel_id}/gift/${id}/`, sitekey)
  return data
}

export const createGift = async (sitekey, wheel_id, gift) => {
  const data = await callApi('POST', `/wheel/${wheel_id}/gift/`, sitekey, gift)
  return data
}

export const updateGift = async (sitekey, wheel_id, gift) => {
  const data = await callApi('PUT', `/wheel/${wheel_id}/gift/${gift.id}/`, sitekey, gift)
  return data
}

export const deleteGift = async (sitekey, wheel_id, gift) => {
  const data = await callApi('DELETE', `/wheel/${wheel_id}/gift/${gift.id}/`, sitekey)
  return data
}

export const getAllGifts = async (sitekey, wheel_id) => {
  const items = []
  const _load = async page => {
    const wheels = await callApi('GET', `/wheel/${wheel_id}/gift`, sitekey)
    items.push(...wheels)
  }
  await _load(0)
  return items
}

export const getStats = async (sitekey, wheelId) => {
  const data = await callApi('GET', `/wheel/${wheelId}/reporting/stats/`, sitekey)
  return data
}



// WEBPACK FOOTER //
// ./src/services/wheel.api.js